import moment from 'moment';
import { DEFAULT_INCLUSIVITY } from '../../constants/datetime';
/**
 * Checks if a program session is going on now
 * @param {object} session Event program item
 * @returns boolean
 */

export function isCurrentSession(session) {
    return moment().isBetween(
        session.start_local,
        session.end_local,
        null,
        DEFAULT_INCLUSIVITY
    );
}
